import React, {PropTypes} from 'react';
import styleComponent from './CustomList.scss';

export class CustomListItem extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    primaryText: PropTypes.node.isRequired,
    secondaryText: PropTypes.node,
    leftItems: PropTypes.node,
    avatar: PropTypes.node,
    rightItems: PropTypes.node
  };

  static defaultProps = {
    className: '',
    style: {}
  };

  render() {
    const {
      className,
      style,
      leftItems,
      primaryText,
      secondaryText,
      avatar,
      rightItems
    } = this.props;

    return (
      <div className={[styleComponent.listItem, className].join(' ')} style={style}>
        {leftItems ? (<div className={styleComponent.leftItems}>{leftItems}</div>) : null}

        {avatar ? (<div className={styleComponent.avatar}>{avatar}</div>) : null}

        <div className={styleComponent.text}>
          <div className={styleComponent.primaryText}>{primaryText}</div>
          {secondaryText ? (<div className={styleComponent.secondaryText}>{secondaryText}</div>) : null}
        </div>

        {rightItems ? (<div className={styleComponent.rightItems}>{rightItems}</div>) : null}

      </div>
    );
  }
}

export default CustomListItem;



// WEBPACK FOOTER //
// ./src/components/common/CustomList/CustomListItem.js